var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden md:flex flex-wrap px-4"},[_c('div',{staticClass:"w-1/3 h-12"},[_vm._t("left")],2),_c('div',{staticClass:"w-1/3 h-12"},[_vm._t("center")],2),_c('div',{staticClass:"w-1/3 h-12"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }